import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-748e1d26"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "accept_protocol_mask"
}
const _hoisted_2 = { class: "accept_protocol_container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "确认开通", -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 我已阅读并同意 ")
const _hoisted_6 = { class: "btn_group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", {
              class: "link",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openUserProtocol && _ctx.openUserProtocol(...args)))
            }, "《用户协议》"),
            _createElementVNode("span", {
              class: "link",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openPrivacyProtocol && _ctx.openPrivacyProtocol(...args)))
            }, "《隐私政策》")
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "common_bottom_btn confirm_btn",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, "同意并开通"),
            _createElementVNode("div", {
              class: "common_bottom_btn cancel_btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, "取消")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}